/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a reasonable estimate — typically within a few percent of methods like DEXA — and is most useful for tracking changes over time with consistent measuring technique.`)
};

const es_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es una estimación razonable — normalmente dentro de unos pocos puntos porcentuales de métodos como el DEXA — y es más útil para seguir cambios en el tiempo con una técnica de medición consistente.`)
};

const de_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie liefert eine solide Schätzung — typischerweise innerhalb weniger Prozentpunkte von Methoden wie DEXA — und eignet sich am besten, um Veränderungen über die Zeit bei konsistenter Messtechnik zu verfolgen.`)
};

const nl_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is een redelijke schatting — meestal binnen een paar procent van methoden zoals DEXA — en is het nuttigst om veranderingen over tijd te volgen met een consistente meettechniek.`)
};

const fr_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est une estimation raisonnable — généralement à quelques pourcents près de méthodes comme le DEXA — et elle est surtout utile pour suivre les changements dans le temps avec une technique de mesure cohérente.`)
};

const it_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È una stima ragionevole — di solito entro qualche punto percentuale rispetto a metodi come la DEXA — ed è particolarmente utile per seguire i cambiamenti nel tempo con una tecnica di misurazione costante.`)
};

const pt_br2_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É uma estimativa razoável — geralmente dentro de poucos pontos percentuais de métodos como o DEXA — e é mais útil para acompanhar mudanças ao longo do tempo com uma técnica de medição consistente.`)
};

const pt_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É uma estimativa razoável — normalmente dentro de alguns pontos percentuais de métodos como a DEXA — e é mais útil para acompanhar mudanças ao longo do tempo com uma técnica de medição consistente.`)
};

const ja_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEXAなどの方法と比べて数パーセント以内に収まる妥当な推定値です。測定方法を一定に保って経時的な変化を追うのに最も役立ちます。`)
};

const zh_bf_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是一种合理的估算方法——通常与 DEXA 等方法的误差在几个百分点以内——最适合在保持一致测量方式的前提下跟踪长期变化。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_a1", locale)
	if (locale === "en") return en_bf_faq_a1(inputs)
	if (locale === "es") return es_bf_faq_a1(inputs)
	if (locale === "de") return de_bf_faq_a1(inputs)
	if (locale === "nl") return nl_bf_faq_a1(inputs)
	if (locale === "fr") return fr_bf_faq_a1(inputs)
	if (locale === "it") return it_bf_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_a1(inputs)
	if (locale === "pt") return pt_bf_faq_a1(inputs)
	if (locale === "ja") return ja_bf_faq_a1(inputs)
	return zh_bf_faq_a1(inputs)
};